import { useState, useEffect } from 'react';
import React from 'react';
import moment from 'moment';
import { getOffboardingData, getReasonDD } from '../service/DirectorAPI';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import Loader from '../StaticComponent/Loader';
import './Offboardcss/CSS/Transition-plan.css';
import { encryptStorage } from '../constant';
import { getReportingEmpId } from '../service/DirectorAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { getDesignation, getReasonType } from '../service/api';

export function HrOffboardingGrid() {
    //useLocation
    let attrition = useLocation();
    let attritionData = attrition.state;

    let offboardGridarray = [];
    const navigate = useNavigate();
    const [offboadGridData, setoffboadGridData] = useState(offboardGridarray);
    const [columnOrder, setColumnOrder] = useState('DESC');
    const [columnName, setColumnName] = useState('created_at');
    const [sorthide, setsorthide] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [arrDropDownReason, setarrDropDownReason] = useState([]);
    const [arrDropDownReasonType, setarrDropDownReasonType] = useState([])
    const [arrDropDownDomain, setarrDropDownDomain] = useState([]);
    const [arrDropDownOffboardStatus, setarrDropDownOffboardStatus] = useState([]);
    const [countPerPage, setCoutPerPage] = useState(10);
    const [dataLength, setDataLength] = useState();
    //For the filter
    const [hideFilterPopUp, sethideFilterPopUp] = useState(true);
    //const [filterValidation,setfilterValidation] = useState("")
    let filData = {
        reason: 0,
        reason_type: 0,
        transitionStatus: '',
        offboardingStatus: '',
        domain: '',
        From: '',
        To: '',
        designation:''
    };
    const [filter, setfilter] = useState(filData);
    //To get the logged in person detailss
    const [role, setrole] = useState(encryptStorage.getItem('role'));
    const [loggedInempId, setloggedInempId] = useState(encryptStorage.getItem('employeeId'));
    const [isLoading, setIsLoading] = useState();
    //reason type 
    const [reasonDropDownReason, setreasonDropDownReason] = useState([]);
    const [designation, setDesignation] = useState([]);

    useEffect(() => {
        loadGridPage();
        loadFilterData();
        LoadReasontype();
        loadDesignation();
    }, [columnName, columnOrder, countPerPage]);
    const loadGridPage = async (filterData = {}) => {
        
        let validReportTo = false;
        
        if (filterData.transitionStatus !== '') {
            filterData = filter;
        }
        if (filterData.designation !== '') {
            filterData = filter;
        }
        try {
            let fromDate = '';
            let toDate = '';

            if (filterData.From) {
                fromDate = `${filterData.From} `;
            }
            if (filterData.To) {
                toDate = `${filterData.To}`;
            }

            let loadData = {
                role: role,
                empID: loggedInempId,
                reason_id: filterData.reason,
                reason_type: filterData.reason_type,
                // reason_type_id: filterData.reason_type,
                search_value: searchValue.trim(),
                designation:filterData.designation,
                transition_status: filterData.transitionStatus,
                offboarding_status: filterData.offboardingStatus,
                domain: filterData.domain,
                sortColumn: columnName,
                sortOrder: columnOrder,
                PageSize: countPerPage,
                From: fromDate,
                To: toDate,
                //adding prop values
                attrition_domain: attritionData?.domain || '',
                attrition_end_date:attritionData?.end_date || '',
                attrition_start_date:attritionData?.start_date|| '',
                attrition_relieving_type:attritionData?.relieving_type || '',
                attrition_gender:attritionData?.gender || '',
                attrition_reason:attritionData?.reason_type || '',
            };
            setIsLoading(false);
            
            let data = await getOffboardingData(loadData);
            switch (encryptStorage.getItem('groupid')) {
                case '1':
                    {
                        validReportTo = true;
                        break;
                    }
                case '2':
                    {
                        if (encryptStorage.getItem("employeeId") == data?.data?.ResponseData[0].emp_id) {
                                validReportTo = true;

                        }
                        else {

                            let request = {
                                login_id: encryptStorage.getItem('employeeId'),
                            };
                            let respdata = await getReportingEmpId(request);

                            for (let i = 0; i < respdata.data.ResponseData?.length; i++) {
                                if (respdata.data.ResponseData[i]?.emp_id === data?.data?.ResponseData[0].emp_id) {
                                    validReportTo = true;
                                }
                                //
                            }
                        }
                        break;
                    }
                
                default:
                    {
                        navigate('*')
                        break;
                    }
                    
            }

            setoffboadGridData(data?.data?.ResponseData[0]);
            setDataLength(data?.data?.ResponseData[1]);
            setIsLoading(true);
        } catch (error) {}
    };
    const sortClicked = (e) => {
        try {
            let sortID = e.target.id;
            let sortval = sortID.split('@');
            setColumnName(sortval[0]);
            setColumnOrder(sortval[1]);
            setsorthide(sortID);
            setSearchValue('');
        } catch (error) {}
    };
    const handleSearchKeyDown = (e) => {
        if (e.charCode == 13) {
            setColumnName('');
            loadGridPage();
        }
    };
    const searchClick = () => {
        setColumnName('');
        loadGridPage();
    };
    const handleLoadMore = () => {
        try {
            setCoutPerPage(countPerPage + 10);
            // loadGridPage()
        } catch (error) {}
    };

    function formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");
      }
    /**
     *
     * Make an  getFilterDD await call and pass the client id
     * we need to set a endpoint , requestType in client function inside the api.js.
     * endpoint will be like passing the parameter and also setting the datatype to the parameters,
     * requestType will be setting the route 'POST' to the client method.
     * To load the drop down in the Filter
     **/
    const loadFilterData = async () => {
        let empdata = {};
        let response = await getReasonDD(empdata);

        setarrDropDownReason(response.data.ResponseData[0]);
        setarrDropDownDomain(response.data.ResponseData[2]);
        setarrDropDownOffboardStatus(response.data.ResponseData[3]);
    };
    /**
     *
     * Build function for the Reason, offboarding Status and Domain
     * to bind the drop down dynamically in the filter
     */
    const buildReason = () => {
        
        return arrDropDownReason.map((value, index) => {
            return (
                <option key={index} value={value.id}>
                    {value.relieving_type}
                </option>
            );
        });
    };

    const LoadReasontype = async () => {
        // let domainData = {};
        let responsedata = await getReasonType({});
        if (responsedata?.data) {
            setreasonDropDownReason(responsedata.data.result);
        }
    };


    const buildReasonType = () => {
        
        return reasonDropDownReason?.map((value, index) => {
            return <option value={value.id}>{value.reason_type}</option>;
        });
    };

    const loadDesignation = async () => {
        
        let responsedata = await getDesignation({});
        if (responsedata?.data) {
            setDesignation(responsedata.data.result);
        }
      
    }


    const buildDesignationType = () => {
        
        return designation?.map((value, index) => {
            return <option value={value.id}>{value.role}</option>;
        });
    };

    const buildOffboardingStatus = () => {
        return arrDropDownOffboardStatus.map((value, index) => {
            return (
                <option key={index} value={value.id}>
                    {value.status}
                </option>
            );
        });
    };
    const buildDomain = () => {
        return arrDropDownDomain.map((value, index) => {
            return (
                <option key={index} value={value.domain}>
                    {value.domain}
                </option>
            );
        });
    };
    const filterClicked = async () => {
        try {
            sethideFilterPopUp(hideFilterPopUp == true ? false : true);
        } catch (error) {
            //window.location.href = '/ErrorPage';
        }
    };
    const handleFilterInput = (e) => {
        try {
            //setfilterValidation("")
            setfilter({ ...filter, [e.target.name]: e.target.value });
        } catch (error) {
        }
    };
    const applyFilter = () => {
        
        // if (filter.From != "" && filter.To != "") {
        //   if (Date.parse(filter.From) > Date.parse(filter.To)) {
        //    setfilterValidation("Start date should be lesser than End date");
        //     return false;
        //   }
        // }
        loadGridPage();
        sethideFilterPopUp(true);
    };
    /**
     *
     * To handle the inputs when the user enters in the fields
     */

    const handleExportExcel = async () => {
        
               if (offboadGridData.length ) {
                 try {
                   setIsLoading(true);
                     let ExportToExcelArray = offboadGridData?.map((item) => {
                        return {
                            Employee_Name: item.emp_name,
                            Role: item.role,
                            Domain: item.domain,
                            Reports_To: item.resportstoname,
                            HR_Incharge: item.hrname,
                            HR_Reasons: item.hr_reason_id,
                            Initiated_By: item.initiated_by_name,
                            Reason_Type: item.reason_type,                            
                            Relieving_Type: item.relieving_type,
                            Last_Working_Date: formatDate(item.last_working_date),
                            Status: item.status,
                            Iniatiated_At: formatDate(item.created_at)
                        };
                   });
                   
                   let newexcel = XLSX.utils.book_new();
                   let data = XLSX.utils.json_to_sheet(ExportToExcelArray);
                   newexcel.SheetNames = ["Offboarding_data"];
                   const offboardingData = XLSX.utils.json_to_sheet(ExportToExcelArray);
                   offboardingData["A1"].s = {};
                   newexcel.Sheets.Offboarding_data = offboardingData;
                  
                   XLSX.writeFile(newexcel, `OffboardingData_${moment().format('YYYY-MM-DD hh_mm_ss')}.xlsx`);
          
                 } catch (e) {
                   console.log("error", e.message);
                 }
                //  setIsLoading(false);
               }
             };

    const filterClearClicked = () => {
        let filData1 = {
            reason: 0,
            reason_type: 0,
            transitionStatus: '',
            offboardingStatus: '',
            domain: '',
            From: '',
            To: '',
            designation:''
            
        };
        setfilter(filData1);
        //setfilterValidation("")
        loadGridPage(filData1);
        sethideFilterPopUp(true);
    };
    const offboardingGridBodyData = () => {
        try {
            if (offboadGridData.length == 0) {
                return (
                    <tr>
                        <td colSpan="10" className="accord-content1">
                            <div className="row justify-content-center">
                                <img
                                    src="Images/nodatafound.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />
                                <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return offboadGridData.map((obj, index) => {
                    let AppliedDate = moment(obj.created_at).format('MMM DD, YYYY');
                    let LastDate = moment(obj.last_working_date).format('MMM DD, YYYY');
                    return (
                        <tr className="offboard-table-data regular-text align-middle">
                            <td> 
                                <div className="d-flex align-items-center">
                                    <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                                    <div className="ms-2">
                                        <p className="table-name-style mb-0">{obj.emp_name}</p>
                                        <p className="table-domain-style mb-0">{obj.role}</p>
                                    </div>
                                </div>
                            </td>
                            <td hidden={role == 'Hr Manager' || role == 'Hr' ? false : true}>{obj.domain}</td>
                            <td>{obj.initiated_by_name}</td>
                            <td>{obj.relieving_type}</td> 
                            <td>{obj.reason_type}</td>
                            {obj.hr_reason_id == null ? <td>-</td> : <td>{obj.hr_reason_id}</td>}
                            {/* <td>{obj.hr_reason_id}</td> */}
                            <td>{AppliedDate}</td>
                            {/* {LastDate == 'Invalid date' ? <td>-</td> : <td>{LastDate}</td>} */}
                            {obj.hrname == null ? <td>-</td> : <td>{obj.hrname}</td>}
                            {/* {obj.transitionstatus == null ? <td>-</td> : null}
                            {obj.transitionstatus == 'Completed' ? <td style={{ color: '#1EB131' }}>{obj.transitionstatus}</td> : null}
                            {obj.transitionstatus == 'In Progress' ? <td style={{ color: '#4466D8' }}>{obj.transitionstatus}</td> : null}
                            {obj.transitionstatus == 'Yet To Start' ? <td style={{ color: '#FF5151' }}>{obj.transitionstatus}</td> : null} */}
                            {obj.status == 'Completed' ? <td style={{ color: '#1EB131' }}>{obj.status}</td> : null}
                            {obj.status == 'In Progress' ? <td style={{ color: '#4466D8' }}>{obj.status}</td> : null}
                            {obj.status == 'Yet To Start' ? <td style={{ color: '#FF5151' }}>{obj.status}</td> : null}
                            {obj.status == 'Approved' ? <td style={{ color: '#1EB131' }}>{obj.status}</td> : null}
                            <td>
                                <a
                                    className=" text-decoration-none table-link-clr"
                                    href={`/offboardingForm?offboarding_Id=${obj.offboarding_id}&mode=Edit&way=grid&emp_id=${obj.emp_id}`}
                                >
                                    view
                                </a>
                            </td>
                        </tr>
                    );
                });
            }
        } catch (error) {}
    };
    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'Team Member', path: '', isActive: true },
        { title: 'Offboarding', path: '', isActive: false },
    ];
    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="mtcustom-5">
                <div className="body-bg">
                    <div className="row justify-content-center mt-3">
                        <div className="col-md-11">
                            <BreadCrumbs data={breadCrumbsData} />
                        </div>
                        <div className="col-md-11 d-flex align-items-center ">
                            <div className="font-15 tt-bold concern-form-label" style={{ marginLeft: '-21px !important' }}>
                                Offboarding
                            </div>
                            {/*Tab Structure Ends Here*/}
                            <div className="ms-auto d-flex">
                                <div className="input-group flex-nowrap search-group me-3 searchClass">
                                    <input
                                        type="search"
                                        className="form-control font-13 search-align "
                                        placeholder="Search by Team member"
                                        aria-label="Username"
                                        aria-describedby="addon-wrapping"
                                        value={searchValue}
                                        onChange={(e) => setSearchValue(e.target.value)}
                                        onKeyPress={(e) => handleSearchKeyDown(e)}
                                    />
                                    <button
                                        className="input-group-text btn btn-search-custom "
                                        style={{ backgroundColor: '#ffff' }}
                                        id="addon-wrapping"
                                        onClick={() => searchClick()}
                                    >
                                        <img src="Images/search-icon.svg" alt="search-icon" />
                                    </button>
                                </div>
                                {/*Filter Section Starts Here*/}
                                <div className="dropdown">
                                    <button
                                        className="advanced-filter-button me-3 medium-text cursor-pointer"
                                        type="button"
                                        aria-expanded="false"
                                        data-bs-toggle="dropdown"
                                        onClick={() => filterClicked()}
                                    >
                                        <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                        Filter
                                    </button>
                                    {/* <div hidden={hideFilterPopUp} className="dropdown-menu px-3 advanced-filter-panel filterClass"  style={hideFilterPopUp == false ? { display: 'block' } : null}> */}

                                    {!hideFilterPopUp ? (
                                        <div
                                            className="dropdown-menu filter-position px-3 advanced-filter-panel"
                                            style={{ display: 'block', marginTop: '-34px' }}
                                        >
                                            <div className="row">
                                                <div className="col-md-12 py-2 border-0 mb-1">
                                                    <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                    <button
                                                        type="button"
                                                        className="btn-close float-end close-filter"
                                                        data-bs-dismiss="advanced-filter"
                                                        aria-label="Close"
                                                        onClick={() => sethideFilterPopUp(true)}
                                                    />
                                                </div>
                                                {/* renamed Reason to Relieving type */}
                                                <div className="col-md-12 ">
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="Domain">
                                                                Relieving Type
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="Domain"
                                                                name="reason"
                                                                value={filter.reason}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            >
                                                                <option value={''}>Select</option>
                                                                {buildReason()}
                                                            </select>
                                                        </div>

                                                        {/* added Reason type */}
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="Domain">
                                                                Reason
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="Domain"
                                                                name="reason_type"
                                                                value={filter.reason_type}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            >
                                                                <option value={''}>Select</option>
                                                                {buildReasonType()}
                                                            </select>
                                                        </div>

                                                        {/* <div className="col-md-6 mb-3 ">
                                                            <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                Designation
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="Approval_status"
                                                                name="transitionStatus"
                                                                value={filter.transitionStatus}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            >
                                                                <option value={''}>Select</option>
                                                                <option value={'null'}>Not yet assigned</option>
                                                                <option value={'Completed'}>Completed</option>
                                                                <option value={'In Progress'}>In Progress</option>
                                                                <option value={'Yet To Start'}>Yet To Start</option>
                                                            </select>
                                                        </div> */}
                                                    </div>
                                                    <div className="col-md-12 ">
                                                        <div className="row mb-3">
                                                            <div className="col-md-6 mb-3">
                                                                <label className="form-label hive-form-label" htmlFor="Domain">
                                                                    Offboarding Status
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="Domain"
                                                                    name="offboardingStatus"
                                                                    value={filter.offboardingStatus}
                                                                    onChange={(e) => handleFilterInput(e)}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {buildOffboardingStatus()}
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label
                                                                    className="form-label hive-form-label"
                                                                    htmlFor="Domain"
                                                                    hidden={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                                                >
                                                                    Domain
                                                                </label>
                                                                <select
                                                                    className="form-select hive-form-select"
                                                                    aria-label="Default select example2"
                                                                    id="Domain"
                                                                    name="domain"
                                                                    value={filter.domain}
                                                                    onChange={(e) => handleFilterInput(e)}
                                                                    hidden={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                                                >
                                                                    <option value={''}>Select</option>
                                                                    {buildDomain()}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {role == 'Hr Manager' || role == 'Hr'?(<div className="col-md-6 mb-3 ">
                                                            <label className="form-label hive-form-label" htmlFor="Approval_status">
                                                                Designation
                                                            </label>
                                                            <select
                                                                className="form-select hive-form-select"
                                                                aria-label="Default select example2"
                                                                id="Approval_status"
                                                                name="designation"
                                                                value={filter.designation}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            >
                                                                <option value={''}>Select</option>
                                                                {buildDesignationType()}
                                                                {/* <option value={'null'}>Not yet assigned</option>
                                                                <option value={'Completed'}>Completed</option>
                                                                <option value={'In Progress'}>In Progress</option>
                                                                <option value={'Yet To Start'}>Yet To Start</option> */}
                                                            </select>
                                                        </div>
                                                        ):<></>}
                                                    <div className="col-md-12 pb-2 border-0 ">
                                                        <span className="font-14 semibold-text filter-title">
                                                            Applied Date
                                                        </span>
                                                    </div>
                                                    <div className="row mb-3">
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="fromrange">
                                                                From
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control hive-form-control"
                                                                id="fromrange"
                                                                name="From"
                                                                max={filter.To}
                                                                value={filter.From}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            />
                                                        </div>
                                                        <div className="col-md-6 mb-3">
                                                            <label className="form-label hive-form-label" htmlFor="forange">
                                                                To
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="form-control hive-form-control"
                                                                id="forange"
                                                                name="To"
                                                                value={filter.To}
                                                                min={filter.From}
                                                                onChange={(e) => handleFilterInput(e)}
                                                            />
                                                        </div>
                                                        {/* <span className='text-danger'>{filterValidation}</span> */}
                                                    </div>
                                                </div>
                                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                                    <button className="btn hive-btn-secondary me-3" onClick={() => filterClearClicked()}>
                                                        Clear
                                                    </button>
                                                    <button className="btn hive-btn-primary" onClick={() => applyFilter()}>
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                {/*Filter Section Ends Here*/}

                                <li  style={{ listStyle: 'none' }}>
                                        <button 
                                        className="btn hive-btn-primary d-inline font-14 font-medium px-4"
                                        type="button" 
                                        id="dropdownMenuButton1" 
                                        data-bs-toggle="dropdown" 
                                        aria-expanded="false"
                                         onClick={(e)=> handleExportExcel(e)}
                                        >
                                            Export to Excel
                                        </button>
                                    </li>

                            </div>
                        </div>
                        {/*Tab Content Starts Here*/}
                        <div className="col-md-11">
                            <div className="tab-content" id="pills-tabContent">
                                {/*All Leave Request Section Starts Here*/}
                                <div
                                    className="tab-pane fade mt-4 active show"
                                    id="all_leave_request"
                                    role="tabpanel"
                                    aria-labelledby="all_leave_request_tab"
                                >
                                    <div className="table-responsive rounded-3">
                                        <table className="table bg-white offboard-grid table-borderless ">
                                            <thead className="offboard-table-head ">
                                                <tr>
                                                    <th className="bold-text font-12">
                                                        Team Members Name
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="emp_name@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'emp_name@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="emp_name@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'emp_name@DESC'
                                                                        ? true
                                                                        : sorthide == 'emp_name@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th
                                                        className="bold-text font-12"
                                                        hidden={role == 'Hr Manager' || role == 'Hr' ? false : true}
                                                    >
                                                        Domain
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="domain@ASC"
                                                                hidden={sorthide == 'domain@ASC' ? true : false}
                                                                onClick={(e) => sortClicked(e)}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="domain@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'domain@DESC'
                                                                        ? true
                                                                        : sorthide == 'domain@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        Initiated By
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="initiated_by_name@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'initiated_by_name@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="initiated_by_name@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'initiated_by_name@DESC'
                                                                        ? true
                                                                        : sorthide == 'initiated_by_name@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        Relieving Type
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="relieving_type@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'relieving_type@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="relieving_type@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'relieving_type@DESC'
                                                                        ? true
                                                                        : sorthide == 'relieving_type@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    {/* added reason type */}
                                                    <th className="bold-text font-12">
                                                        Reason
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="reason_type@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'reason_type@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="reason_type@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'reason_type@DESC'
                                                                        ? true
                                                                        : sorthide == 'reason_type@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        HR's Reason
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="reason_type@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'reason_type@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="reason_type@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'reason_type@DESC'
                                                                        ? true
                                                                        : sorthide == 'reason_type@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="bold-text font-12">
                                                        Applied Date
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="created_at@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'created_at@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="created_at@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'created_at@DESC'
                                                                        ? true
                                                                        : sorthide == 'created_at@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    {/* <th className="bold-text font-12">
                                                        Relieving Date
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="last_working_date@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'last_working_date@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="last_working_date@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'last_working_date@DESC'
                                                                        ? true
                                                                        : sorthide == 'last_working_date@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>

                                                    </th> */}
                                                    <th className="bold-text font-12">
                                                        HR in charge
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="hr_incharge@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'hr_incharge@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="hr_incharge@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'hr_incharge@DESC'
                                                                        ? true
                                                                        : sorthide == 'hr_incharge@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                        {/* <img src="Images/Sort-up.svg" alt="Sorticon" className="hive-table-sort" id="hr_incharge@ASC" onClick={(e) => sortClicked(e)} hidden={sorthide == "hr_incharge@ASC" ? true : false} />
                      <img src="Images/sort-icon.svg" alt="Sorticon" className="hive-table-sort" id="hr_incharge@DESC" onClick={(e) => sortClicked(e)} hidden={sorthide == "hr_incharge@DESC" ? true : sorthide == "hr_incharge@ASC" ? false : true} /> */}
                                                    </th>
                                                    {/* <th className="bold-text font-12">
                                                        Transition Status
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="status@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'status@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="status@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'status@DESC'
                                                                        ? true
                                                                        : sorthide == 'status@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th> */}
                                                    <th className="text-center bold-text font-12">
                                                        Offboarding Status
                                                        <span className="ps-2">
                                                            <img
                                                                src="Images/Sort-up.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="oss.status@ASC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={sorthide == 'oss.status@ASC' ? true : false}
                                                            />
                                                            <img
                                                                src="Images/sort-icon.svg"
                                                                alt="Sorticon"
                                                                className="offboard-table-sort"
                                                                id="oss.status@DESC"
                                                                onClick={(e) => sortClicked(e)}
                                                                hidden={
                                                                    sorthide == 'oss.status@DESC'
                                                                        ? true
                                                                        : sorthide == 'oss.status@ASC'
                                                                        ? false
                                                                        : true
                                                                }
                                                            />
                                                        </span>
                                                    </th>
                                                    <th className="text-center bold-text font-12">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>{offboardingGridBodyData()}</tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                {dataLength > countPerPage ? (
                                    <button
                                        className="btn show-more-btn cursor-pointer !important"
                                        style={{ backgroundColor: 'white' }}
                                        onClick={() => handleLoadMore()}
                                    >
                                        Show More
                                    </button>
                                ) : null}
                            </div>
                            {/*Tab Content Ends Here*/}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
